import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { titleCase } from "./formatter";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function VoteModal({ user, openModal, handleCloseModal }) {
  const leastVote = 300 - user.votes.stage1;
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openModal}
        onClose={handleCloseModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openModal}>
          <Box sx={style}>
            <Typography
              id="transition-modal-title"
              variant="h6"
              fontWeight="bold"
            >
              Hello 👋
            </Typography>
            <Typography
              id="transition-modal-description"
              gutterBottom
              sx={{ mt: 2 }}
            >
              Thanks for checking in.
            </Typography>
            <Typography
              id="transition-modal-description"
              gutterBottom
              // sx={{ mt: 2 }}
            >
              <strong>{titleCase(user.name)}</strong> needs atleast{" "}
              <strong>{leastVote} votes</strong> to make it to the{" "}
              <strong>semi-final</strong> of the Kiddies Crown Contest.
            </Typography>
            <Typography>
              To vote for {user.gender === "Male" ? "him" : "her"}, kindly click
              the <strong>"VOTE"</strong> option at the bottom of this page, and
              follow the prompt.
            </Typography>
            <Box
              sx={{ display: "flex", justifyContent: "right", marginTop: 2 }}
            >
              <Button
                variant="text"
                onClick={handleCloseModal}
                sx={{ fontWeight: "bold" }}
              >
                Okay
              </Button>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
